(function () {
  'use strict';

  if (window.fwdInstagramDmInitialized) return;
  window.fwdInstagramDmInitialized = true;

  let toastTimer = null;

  function showToast(message) {
    let toast = document.querySelector('.fwd-dm-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'fwd-dm-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    window.clearTimeout(toastTimer);
    toast.textContent = message;
    toast.hidden = false;
    toastTimer = window.setTimeout(() => { toast.hidden = true; }, 3200);
  }

  function fallbackCopy(text) {
    const input = document.createElement('textarea');
    input.value = text;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    let copied = false;
    try {
      copied = document.execCommand('copy');
    } catch (error) {
      copied = false;
    }
    input.remove();
    return copied;
  }

  async function copyDmMessage(message) {
    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      try {
        await navigator.clipboard.writeText(message);
        return true;
      } catch (error) {
        return fallbackCopy(message);
      }
    }
    return fallbackCopy(message);
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-fwd-instagram-dm]');
    if (!link) return;
    const message = link.dataset.dmMessage;
    if (!message) return;

    try {
      window.fwdAnalytics?.track?.('Product Inquiry Opened', {
        product_id: link.dataset.productId,
        variant_id: link.dataset.variantId,
        destination: link.dataset.destination || 'instagram_dm',
      });
    } catch (_error) {
      // Opening Instagram must remain independent of analytics.
    }

    copyDmMessage(message).then((copied) => {
      showToast(
        copied
          ? '상품명이 복사되었습니다. Instagram DM 창에 붙여넣어 주세요.'
          : '상품명을 복사하지 못했습니다. DM 창에 상품명을 직접 입력해 주세요.'
      );
    });
  }, true);
})();
